import React, { useEffect, useState } from 'react';

function SVGProgress({ _percentage = 65, showPercentage = true, subTitle = "", amount = 0 }) {
  const [sqSize, setSqSize] = useState(120);
  const [strokeWidth, setStrokeWidth] = useState(15);
  const [percentage, setPercentage] = useState(65);
  const [radius, setRadius] = useState(0);
  const [dashArray, setDashArray] = useState(0);
  const [dashOffset, setDashOffset] = useState(0);
  const [indicatorPos, setIndicatorPos] = useState({ cx: 0, cy: 0 });

  useEffect(() => {
    const validPercentage = _percentage > 100 ? 100 : _percentage;
    setPercentage(showPercentage ? validPercentage : amount);

    const newRadius = (sqSize - strokeWidth) / 2;
    const newDashArray = newRadius * Math.PI * 2;
    const newDashOffset = newDashArray - (newDashArray * validPercentage) / 100;

    const angle = (validPercentage / 100) * 360 - 90;
    const angleInRad = (angle * Math.PI) / 180;
    const cx = sqSize / 2 + newRadius * Math.cos(angleInRad);
    const cy = sqSize / 2 + newRadius * Math.sin(angleInRad);

    setRadius(newRadius);
    setDashArray(newDashArray);
    setDashOffset(newDashOffset);
    setIndicatorPos({ cx, cy });
  }, [_percentage, sqSize, strokeWidth]);

  useEffect(() => {
    const validPercentage = _percentage > 100 ? 100 : _percentage;
    setPercentage(showPercentage ? validPercentage : amount);
  },[showPercentage]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: 5 }}>
      <svg width={sqSize} height={sqSize} viewBox={`0 0 ${sqSize} ${sqSize}`}>
        {/* Background circle */}
        <circle
          cx={sqSize / 2}
          cy={sqSize / 2}
          r={radius}
          stroke="#f1f1f1"
          strokeWidth={strokeWidth}
          fill="none"
        />
        {/* Progress circle */}
        <circle
          cx={sqSize / 2}
          cy={sqSize / 2}
          r={radius}
          stroke="#C8CF52"
          strokeWidth={strokeWidth}
          fill="none"
          strokeDasharray={dashArray}
          strokeDashoffset={dashOffset}
          transform={`rotate(-90 ${sqSize / 2} ${sqSize / 2})`}
          strokeLinecap="round"
        />
        {/* Inner circle */}
        <circle
          cx={sqSize / 2}
          cy={sqSize / 2}
          r={radius - strokeWidth / 2}
          fill="#FDFFEE"
          stroke="#FFFFFF"
          strokeWidth={8}
        />
        {/* Percentage text */}
        <text
          x="50%"
          y="50%"
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize="20"
          fontWeight="bold"
          fill="#000"
        >
          {`${percentage}${showPercentage ? '%' : ''}`}
        </text>
        {/* End circle indicator */}
        <circle
          cx={indicatorPos.cx}
          cy={indicatorPos.cy}
          r={strokeWidth / 2.2}
          fill="#FDFFEE"
          stroke="#C8CF52"
          strokeWidth="4"
        />
      </svg>
      <label style={{ fontSize: 12, color: 'rgba(0,0,0,0.7)' }}>{subTitle}</label>
    </div>
  );
}

export default SVGProgress;
